module.exports = __webpack_public_path__ + "media/simon.087227f1.wav";